import _asyncToGenerator from "/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.function.name.js";
import { computed, defineComponent, ref } from "vue"; //common

import { useI18n } from "vue-i18n"; // modules

import UserModule from "@/store/modules/user";
import POSConfigModule from "@/store/modules/pos-config"; // helpers

import { pushWithQuery, redirectToLoginPage } from "@/utils/helpers/router.helper";
import { dialogVisibleForStatus, hideDialog } from "@/utils/vue-helpers/modal";
import NotificationService from "@/services/notification.service"; // constants

import { ModalStatus } from "@/constants/modal";
import { RouteNames } from "@/constants/router"; // components

import { Spinner } from "@/components/index";
import AuthModule from "@/store/modules/auth";
import { fetchConfigPCs, fetchConfigPicture, fetchConfigTimeslots } from "@/utils/vue-helpers/pos-config";
import AppModule from "@/store/modules/app";
import DeviceModule from "@/store/modules/device";
import { LogService } from "@/services/logging";
import { ElMessageBox } from "element-plus/es/components/message-box";
import ModalModule from "@/store/modules/modal";
import BookingModule from "@/store/modules/booking";
import { hasNonEmptyBookings } from "@/utils/vue-helpers/booking";
import { fetchConfigSeatingPlanParentPCs, proceedFetchAndStoreGroupPicture } from "@/utils/helpers/product-category";
import { fetchNonReccuringSeatingPlanTimeslots } from "@/utils/helpers/timeslots";
import { NetworkErrors } from "@/constants/errors/network";
import { pullAndStorePromocodeCampaigns } from "@/utils/vue-helpers/promocode";
import { loadOffers } from "@/utils/helpers/offers";
import { hasSalesStarted } from "@/utils/vue-helpers/cash-float";
import { syncGroupLocations } from "@/utils/helpers/device";
export default defineComponent({
  name: "PosConfiguration",
  components: {
    Spinner: Spinner
  },
  setup: function setup() {
    var _useI18n = useI18n({}),
        t = _useI18n.t;

    var loading = ref(true);
    var userGroupId = ref(UserModule.getUserGroupId);
    var configs = ref([]); // ref(ConfigurationModule.posConfigs);

    var modalVisibility = dialogVisibleForStatus(ModalStatus.PosConfig);
    var adminUserWithoutGroup = computed(function () {
      return UserModule.isAdminUserWithoutGroup;
    });
    var getLoadingText = computed(function () {
      return POSConfigModule.getLoadingText;
    });
    var progressValue = computed(function () {
      var pcsProgress = POSConfigModule.pcsLoaded;
      var timeslotsProgress = POSConfigModule.timeslotsLoaded;

      if (pcsProgress > 50 || timeslotsProgress) {
        // We don't just keep growing the progress bar
        // we stop it at 60% then it will grow again when the app starts pulling timeslots
        pcsProgress = 50;
      }

      if (timeslotsProgress > 35) {
        // We don't keep growing the progress bar
        // we stop at 95 until timeslots are fully pulled
        timeslotsProgress = 35;
      }

      return 10 + pcsProgress + timeslotsProgress;
    }); // const progressValue = ref<number>(0);

    var configLoading = ref(false);
    /**
     * Load pos configs based on the logged in user group
     * And set them to the state
     */

    function loadConfigs() {
      return _loadConfigs.apply(this, arguments);
    }

    function _loadConfigs() {
      _loadConfigs = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var resp;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                loading.value = true;
                userGroupId.value = UserModule.getUserGroupId;

                if (!userGroupId.value) {
                  _context.next = 27;
                  break;
                }

                _context.prev = 3;
                _context.next = 6;
                return POSConfigModule.fetchUserConfigs(userGroupId.value);

              case 6:
                _context.next = 8;
                return POSConfigModule.fetchGroupInfo();

              case 8:
                _context.next = 18;
                break;

              case 10:
                _context.prev = 10;
                _context.t0 = _context["catch"](3);

                if (!(_context.t0.message.includes(NetworkErrors.NoAccessToken) || _context.t0.message.includes(NetworkErrors.NoSmtzAuthToken))) {
                  _context.next = 16;
                  break;
                }

                return _context.abrupt("return");

              case 16:
                // unexpected error, show a general response error
                NotificationService.showGeneralResponseError();
                return _context.abrupt("return");

              case 18:
                _context.next = 20;
                return proceedFetchAndStoreGroupPicture();

              case 20:
                ////
                // TODO HAMZA LOCATIONS WORK: the below is only for testing. We need to have a better design for locations logic
                LogService.info("Fetching group cash locations");
                _context.next = 23;
                return DeviceModule.fetchLocations();

              case 23:
                resp = _context.sent;
                LogService.info("Group cash locations pulled, attached.", {
                  params: resp
                });
                _context.next = 42;
                break;

              case 27:
                if (!UserModule.isAdmin) {
                  _context.next = 34;
                  break;
                }

                _context.next = 30;
                return AuthModule.UserLogOut();

              case 30:
                // remove gId parameter if it is set
                if (AppModule.gid) {
                  AppModule.removeGID();
                }

                return _context.abrupt("return");

              case 34:
                hideDialog();
                NotificationService.showCustomError(t("error.no-access-right"));
                _context.next = 38;
                return AuthModule.UserLogOut();

              case 38:
                // remove gId parameter if it is set
                if (AppModule.gid) {
                  AppModule.removeGID();
                }

                _context.next = 41;
                return redirectToLoginPage();

              case 41:
                return _context.abrupt("return");

              case 42:
                // @TODO Riyadh clean next line
                configs.value = POSConfigModule.posConfigs;
                loading.value = false;

              case 44:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[3, 10]]);
      }));
      return _loadConfigs.apply(this, arguments);
    }

    function confirmSelectConfig(config) {
      if (POSConfigModule.selectedConfig && config !== POSConfigModule.selectedConfig && hasNonEmptyBookings.value) {
        ElMessageBox.confirm("".concat(this.t("posconfiguration.change-config")), {
          confirmButtonText: "".concat(this.t("common.yes")),
          cancelButtonText: "".concat(this.t("common.return")),
          type: "warning"
        }).then(function () {
          selectConfig(config);
        }).catch(function () {
          ModalModule.setStatus(ModalStatus.Hidden);
        });
      } else {
        selectConfig(config);
      }
    }

    function selectConfig(_x) {
      return _selectConfig.apply(this, arguments);
    }

    function _selectConfig() {
      _selectConfig = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(config) {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                // TODO Victoria: Here when we select config to the state we loose the object selectedConfig.paymentConfig
                // that is already in the state. This caused an issue whenever the user reselect a config, all Adyen
                // payments that he will do will consider the test terminal "...08" because getPosTerminal() getter was based on selectedConfig.paymentConfig
                // --> No need for IPOSConfig.paymentConfig anymore, remove it from the interface and correct Typescript errors
                loading.value = false;
                configLoading.value = true;
                POSConfigModule.SET_SELECTED_CONFIG(config); // clear the selected grid

                console.log("*********** calling selectGrid 4");
                POSConfigModule.selectGrid(null); // if user is allowed to sell through selected config => save POS config in localStorage

                if (!POSConfigModule.getPosConfigPermission) {
                  _context3.next = 35;
                  break;
                }

                // progressValue.value = 10;
                // fetch product categories of the selected config from remote db and store them locally
                POSConfigModule.setLoadingText("loading-tickets");
                _context3.next = 9;
                return fetchConfigPCs(config);

              case 9:
                // progressValue.value = 60;
                POSConfigModule.setLoadingText("loading-timeslots");
                _context3.next = 12;
                return fetchConfigTimeslots(config);

              case 12:
                // At this stage we have the below regarding seating plans:
                // a- sub-categories with parent data
                // b- timeslots of reccuring parent categories (sub-categories in case of seating plan are not linked to timeslots)
                // Now we need to pull the below:
                // c- parent PCs with all their details, then convert them to localFormat, then attach to them an array containing their sub-categories
                // d- none-reccuring parent PCs timeslots
                // why we don't attach to them an array of their timeslots as well? Because we can have a recurring seating plan which is linked to timeslots spread in different dates, and user will later select a different date
                POSConfigModule.setLoadingText("loading-seating-tickets");
                _context3.next = 15;
                return fetchConfigSeatingPlanParentPCs();

              case 15:
                _context3.next = 17;
                return fetchNonReccuringSeatingPlanTimeslots();

              case 17:
                _context3.next = 19;
                return pullAndStorePromocodeCampaigns();

              case 19:
                _context3.next = 21;
                return fetchConfigPicture(config.id);

              case 21:
                _context3.prev = 21;
                _context3.next = 24;
                return loadOffers();

              case 24:
                LogService.info("Offers object instantiated");
                _context3.next = 30;
                break;

              case 27:
                _context3.prev = 27;
                _context3.t0 = _context3["catch"](21);
                LogService.info("Failed to instantiate offers object", {
                  error: _context3.t0
                });

              case 30:
                _context3.next = 32;
                return syncGroupLocations();

              case 32:
                // progressValue.value = 100;
                // Wait for a short delay before hiding the modal
                setTimeout( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                  return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                      switch (_context2.prev = _context2.next) {
                        case 0:
                          // It is sure that every data from remote to start selling is now pulled and stored in local db
                          // lets create a new booking if sales has already started
                          if (hasSalesStarted.value) {
                            console.log("******** calling BookingModule.createNewBooking");
                            BookingModule.createNewBooking();
                          }

                          hideDialog(); // lets reset loading progress

                          POSConfigModule.setPCsLoaded(0);
                          POSConfigModule.setTimeslotsLoaded(0);
                          configLoading.value = true;
                          _context2.next = 7;
                          return pushWithQuery(RouteNames.Booking);

                        case 7:
                        case "end":
                          return _context2.stop();
                      }
                    }
                  }, _callee2);
                })), 500);
                _context3.next = 39;
                break;

              case 35:
                // user is not allowed to sell using selected config => remove POS config and show error notification
                POSConfigModule.removePOSConfig();
                NotificationService.showPosConfigurationError(config.name);
                configLoading.value = false;
                loadConfigs();

              case 39:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, null, [[21, 27]]);
      }));
      return _selectConfig.apply(this, arguments);
    }

    return {
      t: t,
      modalVisibility: modalVisibility,
      loadConfigs: loadConfigs,
      userGroupId: userGroupId,
      configs: configs,
      selectConfig: selectConfig,
      loading: loading,
      adminUserWithoutGroup: adminUserWithoutGroup,
      progressValue: progressValue,
      configLoading: configLoading,
      confirmSelectConfig: confirmSelectConfig,
      getLoadingText: getLoadingText
    };
  },
  mounted: function mounted() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
      return regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _this.loadConfigs();

            case 1:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }))();
  }
});